export const hotComics = [
  {
    id: 'comic-1',
    title: '甜蜜的陷阱',
    author: '金智恩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20comic%20cover%20style%20with%20soft%20warm%20lighting%20and%20gentle%20atmosphere%2C%20pastel%20colors%2C%20minimalist%20illustration%20background%20with%20subtle%20gradient%2C%20Korean%20webtoon%20aesthetic%2C%20dreamy%20romantic%20mood%2C%20clean%20composition&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    category: '恋爱',
    rating: 9.5,
    description: '一个关于意外邂逅的甜蜜爱情故事，当平凡的上班族遇到神秘的设计师，命运的齿轮开始转动。',
    views: 1250000,
    tags: ['恋爱', '都市', '甜宠']
  },
  {
    id: 'comic-2',
    title: '剑与魔法之诗',
    author: '李玄宇',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20comic%20cover%20style%20with%20epic%20atmosphere%2C%20warm%20golden%20lighting%2C%20minimalist%20fantasy%20illustration%20background%2C%20Korean%20webtoon%20aesthetic%2C%20heroic%20mood%2C%20clean%20composition%20with%20subtle%20gradient&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    category: '奇幻',
    rating: 9.7,
    description: '在魔法与剑交织的世界里，少年踏上寻找传说之剑的旅程，友情与冒险并存。',
    views: 2100000,
    tags: ['奇幻', '冒险', '成长']
  },
  {
    id: 'comic-3',
    title: '暗夜追踪者',
    author: '朴志浩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20thriller%20comic%20cover%20style%20with%20dramatic%20warm%20lighting%2C%20minimalist%20action%20illustration%20background%2C%20Korean%20webtoon%20aesthetic%2C%20intense%20mood%2C%20clean%20composition%20with%20subtle%20gradient&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    category: '悬疑',
    rating: 9.3,
    description: '夜幕降临，城市的阴影中隐藏着不为人知的秘密。一位追踪者将揭开层层迷雾。',
    views: 980000,
    tags: ['悬疑', '动作', '推理']
  },
  {
    id: 'comic-4',
    title: '花店物语',
    author: '崔秀雅',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20comic%20cover%20style%20with%20soft%20warm%20natural%20lighting%2C%20floral%20minimalist%20illustration%20background%2C%20Korean%20webtoon%20aesthetic%2C%20peaceful%20mood%2C%20clean%20composition%20with%20subtle%20gradient&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    category: '治愈',
    rating: 9.6,
    description: '街角的花店里，每一朵花都有自己的故事。少女店主用花语治愈每一位客人。',
    views: 1560000,
    tags: ['治愈', '日常', '温暖']
  },
  {
    id: 'comic-5',
    title: '顶级猎人',
    author: '姜胜宇',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20comic%20cover%20style%20with%20dramatic%20warm%20lighting%2C%20minimalist%20hunter%20illustration%20background%2C%20Korean%20webtoon%20aesthetic%2C%20powerful%20mood%2C%20clean%20composition%20with%20subtle%20gradient&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    category: '动作',
    rating: 9.4,
    description: '在怪物横行的世界里，顶级猎人们守护着人类最后的防线，战斗永不停止。',
    views: 1890000,
    tags: ['动作', '热血', '冒险']
  },
  {
    id: 'comic-6',
    title: '时空旅人',
    author: '韩秀晶',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20time%20travel%20comic%20cover%20style%20with%20mysterious%20warm%20lighting%2C%20minimalist%20sci-fi%20illustration%20background%2C%20Korean%20webtoon%20aesthetic%2C%20mysterious%20mood%2C%20clean%20composition%20with%20subtle%20gradient&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    category: '奇幻',
    rating: 9.2,
    description: '一次意外让她拥有了穿越时空的能力，改变过去就能改变未来吗？',
    views: 870000,
    tags: ['奇幻', '穿越', '悬疑']
  },
];

export const newComics = [
  {
    id: 'comic-7',
    title: '校园交响曲',
    author: '郑多彬',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20life%20comic%20cover%20style%20with%20bright%20warm%20lighting%2C%20minimalist%20campus%20illustration%20background%2C%20Korean%20webtoon%20aesthetic%2C%20youthful%20mood%2C%20clean%20composition%20with%20subtle%20gradient&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    category: '校园',
    rating: 9.1,
    description: '音乐教室里传出的钢琴声，揭开了青春最美好的篇章。',
    views: 650000,
    tags: ['校园', '音乐', '青春']
  },
  {
    id: 'comic-8',
    title: '美食猎人',
    author: '吴泰民',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20food%20cooking%20comic%20cover%20style%20with%20warm%20appetizing%20lighting%2C%20minimalist%20food%20illustration%20background%2C%20Korean%20webtoon%20aesthetic%2C%20delicious%20mood%2C%20clean%20composition%20with%20subtle%20gradient&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    category: '美食',
    rating: 9.0,
    description: '追寻传说中的美味，一位年轻厨师展开的环球美食冒险之旅。',
    views: 520000,
    tags: ['美食', '旅行', '治愈']
  },
  {
    id: 'comic-9',
    title: '王室的秘密',
    author: '林恩雅',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20royal%20romance%20comic%20cover%20style%20with%20elegant%20warm%20lighting%2C%20minimalist%20castle%20illustration%20background%2C%20Korean%20webtoon%20aesthetic%2C%20noble%20mood%2C%20clean%20composition%20with%20subtle%20gradient&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    category: '恋爱',
    rating: 9.8,
    description: '隐藏在华丽宫殿背后的惊天秘密，公主与骑士之间的禁忌之恋。',
    views: 2300000,
    tags: ['恋爱', '宫廷', '悬疑']
  },
];

export const categoryComics: Record<string, typeof hotComics> = {
  'romance': [
    {
      id: 'comic-1',
      title: '甜蜜的陷阱',
      author: '金智恩',
      coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20comic%20cover%20style%20with%20soft%20warm%20lighting%20and%20gentle%20atmosphere%2C%20pastel%20colors%2C%20minimalist%20illustration%20background%20with%20subtle%20gradient%2C%20Korean%20webtoon%20aesthetic%2C%20dreamy%20romantic%20mood%2C%20clean%20composition&width=600&height=800&seq=comic-cover-01&orientation=portrait',
      category: '恋爱',
      rating: 9.5,
      description: '一个关于意外邂逅的甜蜜爱情故事，当平凡的上班族遇到神秘的设计师，命运的齿轮开始转动。',
      views: 1250000,
      tags: ['恋爱', '都市', '甜宠']
    },
    {
      id: 'comic-9',
      title: '王室的秘密',
      author: '林恩雅',
      coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20royal%20romance%20comic%20cover%20style%20with%20elegant%20warm%20lighting%2C%20minimalist%20castle%20illustration%20background%2C%20Korean%20webtoon%20aesthetic%2C%20noble%20mood%2C%20clean%20composition%20with%20subtle%20gradient&width=600&height=800&seq=comic-cover-09&orientation=portrait',
      category: '恋爱',
      rating: 9.8,
      description: '隐藏在华丽宫殿背后的惊天秘密，公主与骑士之间的禁忌之恋。',
      views: 2300000,
      tags: ['恋爱', '宫廷', '悬疑']
    },
    {
      id: 'comic-10',
      title: '我们的夏天',
      author: '宋慧乔',
      coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20summer%20romance%20comic%20cover%20style%20with%20bright%20warm%20sunlight%2C%20minimalist%20beach%20illustration%20background%2C%20Korean%20webtoon%20aesthetic%2C%20refreshing%20mood%2C%20clean%20composition%20with%20subtle%20gradient&width=600&height=800&seq=comic-cover-10&orientation=portrait',
      category: '恋爱',
      rating: 9.3,
      description: '夏日海边的邂逅，两个灵魂在最美的季节相遇相知。',
      views: 1100000,
      tags: ['恋爱', '夏日', '治愈']
    },
    {
      id: 'comic-11',
      title: '咖啡店恋人',
      author: '权娜拉',
      coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20coffee%20shop%20romance%20comic%20cover%20style%20with%20cozy%20warm%20lighting%2C%20minimalist%20cafe%20illustration%20background%2C%20Korean%20webtoon%20aesthetic%2C%20intimate%20mood%2C%20clean%20composition%20with%20subtle%20gradient&width=600&height=800&seq=comic-cover-11&orientation=portrait',
      category: '恋爱',
      rating: 9.0,
      description: '一杯拿铁的温度，刚好是37.5度，和心跳一样温暖。',
      views: 780000,
      tags: ['恋爱', '日常', '温暖']
    },
  ],
  'fantasy': [
    {
      id: 'comic-2',
      title: '剑与魔法之诗',
      author: '李玄宇',
      coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20comic%20cover%20style%20with%20epic%20atmosphere%2C%20warm%20golden%20lighting%2C%20minimalist%20fantasy%20illustration%20background%2C%20Korean%20webtoon%20aesthetic%2C%20heroic%20mood%2C%20clean%20composition%20with%20subtle%20gradient&width=600&height=800&seq=comic-cover-02&orientation=portrait',
      category: '奇幻',
      rating: 9.7,
      description: '在魔法与剑交织的世界里，少年踏上寻找传说之剑的旅程，友情与冒险并存。',
      views: 2100000,
      tags: ['奇幻', '冒险', '成长']
    },
    {
      id: 'comic-6',
      title: '时空旅人',
      author: '韩秀晶',
      coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20time%20travel%20comic%20cover%20style%20with%20mysterious%20warm%20lighting%2C%20minimalist%20sci-fi%20illustration%20background%2C%20Korean%20webtoon%20aesthetic%2C%20mysterious%20mood%2C%20clean%20composition%20with%20subtle%20gradient&width=600&height=800&seq=comic-cover-06&orientation=portrait',
      category: '奇幻',
      rating: 9.2,
      description: '一次意外让她拥有了穿越时空的能力，改变过去就能改变未来吗？',
      views: 870000,
      tags: ['奇幻', '穿越', '悬疑']
    },
    {
      id: 'comic-12',
      title: '龙之契约',
      author: '南宫贤',
      coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20dragon%20fantasy%20comic%20cover%20style%20with%20majestic%20warm%20golden%20lighting%2C%20minimalist%20dragon%20illustration%20background%2C%20Korean%20webtoon%20aesthetic%2C%20epic%20mood%2C%20clean%20composition%20with%20subtle%20gradient&width=600&height=800&seq=comic-cover-12&orientation=portrait',
      category: '奇幻',
      rating: 9.5,
      description: '与远古巨龙签订契约的少年，背负起拯救世界的命运。',
      views: 1650000,
      tags: ['奇幻', '龙', '史诗']
    },
  ],
  'action': [
    {
      id: 'comic-5',
      title: '顶级猎人',
      author: '姜胜宇',
      coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20comic%20cover%20style%20with%20dramatic%20warm%20lighting%2C%20minimalist%20hunter%20illustration%20background%2C%20Korean%20webtoon%20aesthetic%2C%20powerful%20mood%2C%20clean%20composition%20with%20subtle%20gradient&width=600&height=800&seq=comic-cover-05&orientation=portrait',
      category: '动作',
      rating: 9.4,
      description: '在怪物横行的世界里，顶级猎人们守护着人类最后的防线，战斗永不停止。',
      views: 1890000,
      tags: ['动作', '热血', '冒险']
    },
  ],
};

export const allComics = [...hotComics, ...newComics];